const SERVER_HUBS = new Set([
  'runtime',
  'services',
  'sites',
  'domain-certificates',
  'timeline',
  'new',
]);

/** Pages that still have a right-hand column. Everything else is one column. */
export type AsideMode = 'overview' | 'certs' | 'server';

/** `/servers/:id` only. Hub leaves, create, and edit stay out of the server aside. */
export function serverDetailId(pathname: string): string | null {
  const parts = pathname.split('/').filter(Boolean);
  if (parts[0] !== 'servers' || parts.length !== 2) return null;
  if (SERVER_HUBS.has(parts[1])) return null;
  return decodeURIComponent(parts[1]);
}

export function asideMode(pathname: string): AsideMode | null {
  if (pathname === '/') return 'overview';
  if (
    pathname === '/servers/domain-certificates' ||
    pathname.startsWith('/servers/domain-certificates/')
  ) {
    return 'certs';
  }
  if (serverDetailId(pathname)) return 'server';
  return null;
}
